import { config, appFetch } from './appFetch';

export const findApplicationData = (language, onSuccess, onErrors) =>
    appFetch(`/application_parameter/`, config('GET', null, language), onSuccess, onErrors);